import FastNoiseLite from "fastnoise-lite";

import { Char } from './Char.js';
import { Ease } from './Ease.js';

export const Rndm = {

    max: function (max: number): number { //returns ints between 0 and max number
        return Math.floor((Math.random() * (max + 1)));
    },

    between: function (min: number = 0, max: number = 1): number { //int
        return Math.floor(Math.random() * (max - min)) + min;
    },

    range: function (min: number, max: number): number { //floats
        return min + Math.random() * (max - min);
    },

    norm: function (scale: number = 1): number { //0 to 1
        return Math.random() * scale;
    },

    float: function (scale: number = 1): number { //return -1 to 1
        return (Math.random() * 2 - 1) * scale;
    },

    radian: function (): number {
        return Math.random() * Math.PI * 2;
    },

    gaussian: function (): number { //returns 0 - 1, but more likely towards 0.5
        const u = Math.random(), v = Math.random();
        const num = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
        if (num > 1 || num < 0) return Rndm.gaussian(); // Re-sample if outside [0,1]
        return num;
    },

    int: function (): -1 | 0 | 1 { //returns -1, 0 or 1
        const values: (-1 | 0 | 1)[] = [-1, 0, 1];
        return values[Math.floor(Math.random() * values.length)];
    },

    risk: function (trials: number): boolean | undefined {
        if (Math.floor(Math.random() * trials) + 1 == trials) {
            return true;
        }
        return undefined;
    },

    id: function (id: string = "t", idLength: number = 8, charSet: string = Char.all_letters): string {
        for (let i = 0; i < idLength; i++) {
            let randomPoz = Math.floor(Math.random() * charSet.length);
            id += charSet.substring(randomPoz, randomPoz + 1);
        }
        return id;
    },

    color: function (alpha: number = 1, factor: number = 4): [number, number, number, number] {
        const strong_color: [number, number, number, number] = [Ease.powInOut(this.norm(), factor), Ease.powInOut(this.norm(), factor), Ease.powInOut(this.norm(), factor), alpha];
        return strong_color;
    },

    entry: function <T>(ia: T[]): T {
        return ia[Math.floor(Math.random() * ia.length)];
    },

    number: function (max: number = 100): number {
        return Math.floor(Math.random() * max);
    },

    fast: new FastNoiseLite(),
    reset: function (): void {
        this.fast = new FastNoiseLite();
    }
};